import { QueryFunctionContext } from "react-query";
import { IOrderedItem, IPaginatedResponce } from "@drone-parts.garphild.pro/interfaces";
import RestApiQuery from "../../helpers/rest-api-query";

export async function fetchDPendingItems(context: QueryFunctionContext): Promise<IPaginatedResponce<IOrderedItem>> {
  const [key, queryParams] = context.queryKey as [string, { page: number; pageSize: number }];

  const { page, pageSize } = queryParams;

  const data = await RestApiQuery.get<IPaginatedResponce<IOrderedItem>>(`/api/v2/orders/pending`, { page, pageSize });

  return {
    data: data?.data || [],
    total: 0,
    page: 0,
    pageSize: 0,
    totalPages: 0,
    hasNext: false,
    hasPrev: false,
  };
}
